import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useSelector } from "react-redux";
import { dateShortString } from "utils/date-format";
import FormattedAmount from "vino/core/FormattedAmount";

const OrderSummary = ({ title }) => {
	const eventInformation = useSelector(
		({ vino }) => vino.eventBooking.eventInformation
	);

	const eventPackage = useSelector(({ vino }) => vino.eventBooking.package);

	if (!eventInformation || !eventPackage) {
		return null;
	}
	const { eventDate, numberOfGuests, slot } = eventInformation;
	const { costPerPerson } = eventPackage;
	return (
		<div className="w-full pl-10 ">
			<div className="px-8 pt-20">
				<Typography className="text-16 font-medium">{title} </Typography>
			</div>
			<div className="px-24">
				<OrderSummaryItem title="Date" value={dateShortString(eventDate)} />
				<OrderSummaryItem
					title="Time slot"
					value={`${slot.start} - ${slot.end}`}
				/>
				<OrderSummaryItem title="# Guests" value={numberOfGuests} />
				<OrderSummaryItem
					title="Price per guest"
					value={<FormattedAmount value={costPerPerson} />}
				/>
				<OrderSummaryItem
					title="Total"
					value={<FormattedAmount value={numberOfGuests * costPerPerson} />}
				/>
			</div>
		</div>
	);
};

export default OrderSummary;

const OrderSummaryItem = ({ title, value }) => {
	return (
		<>
			<div className="flex justify-between w-full my-12">
				<Typography className="text-15 font-medium">{title}</Typography>
				<div className="flex items-center">
					<Typography className="text-20 font-medium tracking-tighter">
						{value}
					</Typography>
				</div>
			</div>
			<Divider className="my-5" />
		</>
	);
};
